import React from "react"
import classNames from "classnames"

export interface AiInsightsPendingProps {
	message?: string
}

export function AiInsightsEmpty({message = "No Results"}: AiInsightsPendingProps) {
	return (
		<span className={classNames("ai-insights-pending")}>
			<span className="ai-insights-pending-label">{message}</span>
		</span>
	)
}
